import type { Actions } from '../../store';
import type { FlightSegment } from '../../types';

/**
 * Синхронизирует обратную ссылку у парного RT-рейса.
 * Снимает связь со старого партнёра (если он сменился) и проставляет
 * связь новому партнёру.
 */
export function syncLinkedTo(
  actions: Actions,
  id: string,
  prevLinked: string | undefined,
  nextLinked: string | undefined,
): void {
  if (prevLinked && prevLinked !== nextLinked) {
    const clearPatch: Partial<FlightSegment> = { linkedTo: undefined };
    actions.updateSegment(prevLinked, clearPatch);
  }
  if (nextLinked && nextLinked !== prevLinked) {
    const setPatch: Partial<FlightSegment> = { linkedTo: id };
    actions.updateSegment(nextLinked, setPatch);
  }
}
